import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config/api';

const useFooter = () => {
  const [footerContent, setFooterContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFooterContent = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/content/footer`);
        if (!response.ok) {
          throw new Error(`Failed to fetch footer content: ${response.statusText}`);
        }
        const data = await response.json();
        setFooterContent(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching footer content:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFooterContent();
  }, []);

  return { footerContent, loading, error };
};

export default useFooter;
